module.exports = __webpack_public_path__ + "static/media/backCross.36294b0e.svg";